// TODO: [ddd-cleanup @replenishment, @content] - duplicate required constructs in this file into your domain directory.

export enum Color {
    BLACK = 'black',
    BROWN = 'brown',
    GRAY = 'gray',
    GREEN = 'green',
    PINK = 'pink',
    BEIGE = 'beige',
    RED = 'red',
    YELLOW = 'yellow',
    VIOLET = 'violet',
    BLUE = 'blue',
    ORANGE = 'orange',
    GOLD = 'gold',
    SILVER = 'silver',
    MULTICOLOR = 'multicolor',
    WHITE = 'white'
}

const colorToIconPath = {
    [Color.BLACK]: 'assets/svg/colors/black.svg',
    [Color.BROWN]: 'assets/svg/colors/brown.svg',
    [Color.GRAY]: 'assets/svg/colors/grey.svg',
    [Color.GREEN]: 'assets/svg/colors/green.svg',
    [Color.PINK]: 'assets/svg/colors/pink.svg',
    [Color.BEIGE]: 'assets/svg/colors/beige.svg',
    [Color.RED]: 'assets/svg/colors/red.svg',
    [Color.YELLOW]: 'assets/svg/colors/yellow.svg',
    [Color.VIOLET]: 'assets/svg/colors/violet.svg',
    [Color.BLUE]: 'assets/svg/colors/blue.svg',
    [Color.ORANGE]: 'assets/svg/colors/orange.svg',
    [Color.GOLD]: 'assets/svg/colors/gold.svg',
    [Color.SILVER]: 'assets/svg/colors/silver.svg',
    [Color.MULTICOLOR]: 'assets/svg/colors/multicolor.svg',
    [Color.WHITE]: 'assets/svg/colors/white.svg'
};

const colorToIconWithCrossPath = {
    [Color.BLACK]: 'assets/svg/colors/withCross/black.svg',
    [Color.BROWN]: 'assets/svg/colors/withCross/brown.svg',
    [Color.GRAY]: 'assets/svg/colors/withCross/grey.svg',
    [Color.GREEN]: 'assets/svg/colors/withCross/green.svg',
    [Color.PINK]: 'assets/svg/colors/withCross/pink.svg',
    [Color.BEIGE]: 'assets/svg/colors/withCross/beige.svg',
    [Color.RED]: 'assets/svg/colors/withCross/red.svg',
    [Color.YELLOW]: 'assets/svg/colors/withCross/yellow.svg',
    [Color.VIOLET]: 'assets/svg/colors/withCross/violet.svg',
    [Color.BLUE]: 'assets/svg/colors/withCross/blue.svg',
    [Color.ORANGE]: 'assets/svg/colors/withCross/orange.svg',
    [Color.GOLD]: 'assets/svg/colors/withCross/gold.svg',
    [Color.SILVER]: 'assets/svg/colors/withCross/silver.svg',
    [Color.MULTICOLOR]: 'assets/svg/colors/withCross/multicolor.svg',
    [Color.WHITE]: 'assets/svg/colors/withCross/white.svg'
};

export function getFormattedColor({ code, name }: { code: string; name: string }) {
    return `${code ? code : ''}${code && name ? '-' : ''}${name ? name : ''}`;
}

export function getIconFromColor(color: Color): string {
    return colorToIconPath[color];
}

export function getIconWithCrossFromColor(color: Color): string {
    return colorToIconWithCrossPath[color];
}
